<template>
  <div class="earnings-page">
    <h2>推荐收益</h2>
    <el-skeleton v-if="loading" rows="4" animated />
    <template v-else-if="summary">
      <el-row :gutter="16" class="stats">
        <el-col :xs="24" :sm="12">
          <el-statistic title="推荐绑定人数" :value="summary.directBindingsCount" />
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-statistic title="礼遇收益合计（元）" :value="centsToYuan(summary.referrerBonusTotalCents)" :precision="2" />
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-statistic title="专属权益收益·已到账（元）" :value="centsToYuan(summary.partnerSettledCents)" :precision="2" />
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-statistic title="专属权益收益·待到账（元）" :value="centsToYuan(summary.partnerPendingCents)" :precision="2" />
        </el-col>
      </el-row>
      <p v-if="summary.isPartner" class="partner-tag">
        <el-tag type="warning">已开通臻享资格</el-tag>
      </p>
      <p v-else class="hint">开通臻享资格后，可创建「臻享礼券」并享有更多专属权益。</p>
    </template>

    <el-card class="bind-card" shadow="never">
      <h3>绑定礼券</h3>
      <p class="hint">注册后 7 天内可补绑（与注册时填券二选一，终身仅可绑定一张推荐券）。</p>
      <el-button link type="primary" @click="$router.push('/referral/bind-coupon')">前往绑定页</el-button>
      <el-input v-model="bindNo" placeholder="输入推荐券号码" style="max-width: 280px; margin-right: 12px" @blur="checkCoupon" />
      <el-button type="primary" :loading="binding" @click="bindCoupon">绑定</el-button>
      <p v-if="bindHint" class="field-hint">{{ bindHint }}</p>
    </el-card>

    <el-button @click="$router.push('/referral/coupons')">管理我的推荐券</el-button>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ReferralEarningsView',
  data() {
    return {
      loading: true,
      binding: false,
      summary: null,
      bindNo: '',
      bindHint: ''
    }
  },
  created() {
    if (!localStorage.getItem('jwt_token')) {
      this.$goToLogin(this.$route.fullPath)
      return
    }
    this.loadSummary()
  },
  methods: {
    centsToYuan(cents) {
      return (Number(cents || 0) / 100)
    },
    async loadSummary() {
      this.loading = true
      try {
        const res = await axios.post('/api/v1/referral/earnings/summary', {})
        if (res.data.code === 200) {
          this.summary = res.data.data
        }
      } catch (e) {
        this.$message.error(e.response?.data?.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    async checkCoupon() {
      const no = (this.bindNo || '').trim()
      if (!no) {
        this.bindHint = ''
        return
      }
      try {
        const res = await axios.get('/api/v1/referral/coupon/check', { params: { couponNo: no } })
        const data = res.data.data
        if (data?.valid) {
          this.bindHint = data.message || `「${data.displayName}」可绑定`
        } else {
          this.bindHint = data?.message || '推荐券无效'
        }
      } catch {
        this.bindHint = ''
      }
    },
    async bindCoupon() {
      const no = (this.bindNo || '').trim()
      if (!no) {
        this.$message.warning('请输入推荐券号码')
        return
      }
      this.binding = true
      try {
        const res = await axios.post('/api/v1/referral/bind', { couponNo: no })
        if (res.data.code !== 200) {
          this.$message.error(res.data.message || '绑定失败')
          return
        }
        this.$message.success(res.data.message || '绑定成功')
        this.bindNo = ''
        this.bindHint = ''
        await this.loadSummary()
      } catch (e) {
        this.$message.error(e.response?.data?.message || '绑定失败')
      } finally {
        this.binding = false
      }
    }
  }
}
</script>

<style scoped>
.earnings-page { max-width: 720px; margin: 0 auto; padding: 24px 16px; }
.stats { margin: 20px 0; }
.hint { color: #606266; font-size: 14px; }
.bind-card { margin: 24px 0; }
.field-hint { color: #67c23a; margin-top: 8px; font-size: 13px; }
.partner-tag { margin-top: 12px; }
</style>
